Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.QueryDateShifter

  constructor: (query)->
    @query = query
    @queryJSON = @query.toJSON()

  shiftXDaysBack: (days) ->
    new_query = @query.deepCopy()
    new_query.addDateFrom(@_shiftDate(@_dateFrom(),days)) unless @_isAllHistory()
    new_query.addDateTo(@_shiftDate(@_dateTo(),days))
    new_query.removeDateFromRealtime()
    return new_query

  normalQuery: ->
    old_query = @query.deepCopy()
    old_query.addDateFrom(@_dateFrom()) unless @_isAllHistory()
    old_query.addDateTo(@_dateTo())
    old_query.removeDateFromRealtime()
    return old_query

  _shiftDate: (date, days) ->
    date.setDate(date.getDate() - days)
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    if date < threeYearsAgo
      console.warn('QueryDateShifter: shifted date is more than 3 years in the past; clamping lower bound to 3 years ago.')
      date = threeYearsAgo
    date

  _dateFrom: ->
    if @queryJSON.date_from_realtime
      @_dateFromRealtime()
    else 
      if @queryJSON.date_from_ISO
        new Date(@queryJSON.date_from_ISO)
      else
        new Date(@queryJSON.post_from_ISO)


  _dateTo: ->
    if @queryJSON.date_now || @queryJSON.date_from_realtime
      new Date()
    else 
      if @queryJSON.date_to_ISO 
        new Date(@queryJSON.date_to_ISO)
      else
        new Date()

  _dateFromRealtime: ->
    dateFrom = new Date()
    if @queryJSON.date_from_realtime.value == 'current_day' 
      dateFrom.setHours(0,0,0,0)
    else
      dateFrom.setTime(dateFrom.getTime() - @queryJSON.date_from_realtime.value * 60000)
    dateFrom

  _isAllHistory: ->
    res = false
    if @queryJSON  
      if @queryJSON.date_from_realtime
        if @queryJSON.date_from_realtime.value == 'all_history'
          res = true
    res
